import actionTypes from 'redux/actions/actionTypes'
import whiteboardRoles from 'helpers/enums/whiteboardRoles'
import whiteboardModes from 'helpers/enums/whiteboardModes'

const defaultState = {
	actions: {
		teacher: [],
	},
	role: '',
	slideId: '',
	id: '',
	phoenixSessionId: '',
	currentDrawingId: '',
	mode: whiteboardModes.NONE,
}


function updateLocalActions(state, action) {

	return {
		...state,
		actions: {
			...state.actions,
			teacher: action.actions,
		},
	}
}


function updateActions(state, action) {

	if (state.role === whiteboardRoles.TEACHER || !action.actions.length) {
		return state
	}
	const actions = action.actions
	const newActions = [...(state.actions.teacher || [])]
	const newEndAction = actions[actions.length - 1]
	const newFirstAction = actions[0]

	if (newEndAction.index === -1) {
		newActions.splice(0, newActions.length)
	// handling undos
	} else if (newEndAction.messageStatus === 'end signal'
		|| newEndAction.index < newActions.length - 1) {
		newActions.splice(newEndAction.index + 1, newActions.length - 1)
	}
	// handling missing actions filling it with noops
	while (newActions.length < newFirstAction.index + 1) {
		newActions.push({
			index: newActions.length,
			actionType: 'noop',
		})
	}
	actions.forEach(action => {
		const currentAction = newActions[action.index]
		if (currentAction
			&& currentAction.actionId === action.actionId
			&& currentAction.revision !== action.revision) {
			let traces
			if (action.traces) {
				traces = [...currentAction.traces, ...action.traces]
			}
			newActions[action.index] = {
				...currentAction,
				...action,
			}
			if (traces) {
				newActions[action.index].traces = traces
			}
		} else if (action.messageStatus !== 'end signal') {
			newActions[action.index] = action
		}
	})

	return {
		...state,
		actions: {
			...state.actions,
			teacher: newActions,
		},
	}
}

const startSlide = (state, action) => ({
	...defaultState,
	role: action.role,
	slideId: action.slideId,
	phoenixSessionId: action.sessionId,
})

function initializeWhiteboard(state, action) {

	const {currentMode, id, currentDrawingId} = action.whiteboard

	return {
		...state,
		mode: currentMode,
		id,
		currentDrawingId,
	}
}

function initializeDrawing(state, action) {
	const newActions = [...action.data.actions]
	const localActions = state.actions.teacher

	const newFirstAction = localActions[0] || {index: -1}

	while (newActions.length < newFirstAction.index + 1) {
		newActions.push({
			index: newActions.length,
			actionType: 'noop',
		})
	}

	localActions.forEach((action, index) => {
		if (action.actionType !== 'noop') {
			newActions[index] = action
		}
	})

	return {
		...state,
		actions: {
			...state.actions,
			teacher: newActions,
		},
	}
}

function enableWhiteboard(state, action) {
	return {
		...state,
		mode: action.mode,
		currentDrawingId: '',
		actions: defaultState.actions,
	}
}

function handleWhiteboardEnabled(state, action) {
	return {
		...state,
		...action.data,
		actions: defaultState.actions,
	}
}

function disableWhiteboard(state) {
	return {
		...state,
		mode: whiteboardModes.NONE,
		currentDrawingId: '',
		actions: defaultState.actions,
	}
}

function resetWhiteboard() {
	return defaultState
}

const whiteboardReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.WHITEBOARD_MOUNTED:
		case actionTypes.WHITEBOARD_UPDATED:
			return startSlide(state, action)
		case actionTypes.WHITEBOARD_ACTIONS_RECEIVED:
			return updateActions(state, action)
		case actionTypes.WHITEBOARD_ACTIONS_CHANGED:
			return updateLocalActions(state, action)
		case actionTypes.WHITEBOARD_FETCHED:
			return initializeWhiteboard(state, action)
		case actionTypes.WHITEBOARD_ENABLE:
			return enableWhiteboard(state, action)
		case actionTypes.WHITEBOARD_ENABLED:
			return handleWhiteboardEnabled(state, action)
		case actionTypes.WHITEBOARD_DISABLE:
		case actionTypes.WHITEBOARD_DISABLED:
			return disableWhiteboard(state, action)
		case actionTypes.WHITEBOARD_UMOUNTED:
			return resetWhiteboard(state, action)
		case actionTypes.WHITEBOARD_DRAWING_FETCHED:
			return initializeDrawing(state, action)
		default:
			return state
	}
}

export default whiteboardReducer

export {
	defaultState,
}
